import { useContext, useState } from 'react'
import { v4 as uuidv4 } from 'uuid';
import { Box, Grid, LinearProgress, SvgIcon, TextField } from '@mui/material'
import { DataContext, DataDispatchContext } from '../../../contexts/data/dataContext'
import { 
  iconUp,
} from '../../common/iconPaths'
import custom from '../../../styles/mui/szVariables.json'
import { analyticsCta, analyticsDomain } from '../../../services/constants'
import { sendClickAnalytics } from '../../common/util/util'

export default function ChatEntry() {
  const data = useContext(DataContext)
  const dispatch: any = useContext(DataDispatchContext)
  const [question, setQuestion] = useState('');
  const [chatWindow, setChatWindow] = useState(data?.chat.chatWindow || 10);

  function handleQuestion() {
    window.scrollTo({ 
        left: 0, 
        top: document.body.scrollHeight, behavior: "smooth" 
      });
    if(question) {
      sendClickAnalytics('/help', {
            domain: analyticsDomain.assistant,
            name: analyticsCta.sendMessage,
            metadata: {},
          })   
      dispatch({
        type: 'newAiConversation',
        message: question,
        from: 'user',
        chatWindow,
        key: uuidv4()
      })
      data.askAIhelp(question)
      setQuestion('')
      setChatWindow(chatWindow+5)
    }
  }

  function handleEnterKey(ev: any) {
    if(ev.key === "Enter") {
      handleQuestion()
    }
  }

  return (
      <Box 
          bottom={{
            xs: 0,
            sm:"74px",
            md:"74px",
            lg: 0,
            xl: 0,
            xxl: 0
          }} 
          position='fixed' 
          boxSizing={"border-box"}
          maxWidth = {{
            xs:'100%', 
            sm:'400px', 
            md:'400px', 
            lg:'400px' 
          }} 
          width={{
            xs:"100%", 
            sm:'320px', 
            md:"100%", 
            lg:"100%"
          }}
          mx={{
            sx: custom.spacing.xxs,
            sm:0,
            md:0,
            lg:0
          }}
          sx={{
            backgroundColor:'sz.colors.background',
            zIndex: 99,
          }}>   
        <LinearProgress sx={{
            display: `${data.chat?.asking?'block':'none'}`
          }} />   
        <Grid container p={custom.spacing.sm}
            maxWidth = '100%'
            width="100%">
            <Grid item xs={10} 
                pl={custom.spacing.xxs}>
                <TextField id="chat-entry" 
                  placeholder="Ask anything" 
                  fullWidth 
                  value={question}
                  onKeyUp={handleEnterKey}
                  onChange={(e)=>setQuestion(e.target.value)}
                  InputProps={{ sx: { 
                    backgroundColor: '#FFF', 
                    borderRadius: custom.corners4,
                    height: custom.sizes.xl
                  }}}
                />
            </Grid>
            <Grid item xs={2} alignItems={"right"}>
                <Box onClick={handleQuestion}
                      sx={{ 
                        ml: custom.spacing.xxs, 
                        mt: custom.spacing.xxxs, 
                        height: '40px', 
                        width: '40px',
                        cursor: 'pointer'
                      }}>
                    <SvgIcon viewBox='0 0 40 40'
                      sx={{ 
                          height: '40px', 
                          width: '40px',
                          borderColor: 'primary.main'
                      }}>
                      {iconUp}
                    </SvgIcon>
                </Box>
            </Grid>
        </Grid>
      </Box>
  )
}
